import { forwardRef } from 'preact/compat';
import { useImperativeHandle, useRef, useState } from 'preact/hooks';

export type ToastRef = {
  open: (message: string, duration?: number) => void;
};

export const Toast = forwardRef((_, ref) => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const visibleTimeout = useRef<NodeJS.Timeout | undefined>();
  const messageTimeout = useRef<NodeJS.Timeout | undefined>();

  useImperativeHandle(ref, () => ({
    open: (message: string, duration = 2000) => {
      clearTimeout(visibleTimeout.current);
      clearTimeout(messageTimeout.current);

      setMessage(message);
      setVisible(true);

      visibleTimeout.current = setTimeout(() => setVisible(false), duration);
      messageTimeout.current = setTimeout(() => setMessage(null), duration + 300);
    },
  }));

  return (
    <div className="toast-container">
      <div className={`toast ${visible ? 'fade-in' : 'fade-out'}`}>
        {!!message && <div className="toast-content">{message}</div>}
      </div>
    </div>
  );
});
